import React from 'react'
import type { Icon } from 'shared/utils'

const TerraceTable = (props: Icon) => {
    const {
        color = 'black',
        size = 23,
        className = 'terrace-table',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 23 23"
            {...otherProps}>
            <g transform="translate(-1)" fill="none" fillRule="evenodd">
                <g fill={color} fillRule="nonzero">
                    <path d="M23.668 5.65L12.742.135a.536.536 0 00-.484 0L1.332 5.651a.536.536 0 00.242 1.015h10.39v7.558H7.057a.537.537 0 100 1.073h.715v1.039c0 .296.24.536.537.536h3.615v3.318h-.293a.537.537 0 00-.536.537v1.123h-1.52a.537.537 0 100 1.073h5.527a.537.537 0 100-1.073H13.83v-1.123a.537.537 0 00-.537-.537h-.293v-3.318h3.691c.297 0 .537-.24.537-.536v-1.039h.715a.537.537 0 100-1.073h-4.905V6.666h10.39a.537.537 0 00.241-1.015zM12.17 21.85v-.587h.586v.587h-.586zm3.985-6.05H8.846v-.503h7.308v.502zM9.572 5.592L12.5 1.294l2.928 4.299H9.572zm1.597-3.706L8.644 5.593H3.827l7.342-3.706zm5.187 3.706L13.83 1.887l7.342 3.706h-4.817z" />
                    <path d="M22.7 11.981a.537.537 0 00-.536.537v4.704H18.04c-.75 0-1.36.61-1.36 1.36 0 .701.531 1.28 1.213 1.353v2.452a.537.537 0 101.073 0v-1.034h3.198v1.034a.537.537 0 101.073 0v-9.869a.536.536 0 00-.536-.537zm-4.947 6.601c0-.158.129-.287.287-.287h4.124v.575H18.04a.288.288 0 01-.287-.288zm1.213 2.004v-.642h3.198v.642h-3.198zM6.96 17.222H2.835v-4.704a.537.537 0 10-1.073 0v9.869a.537.537 0 101.073 0v-1.034h3.198v1.034a.537.537 0 101.073 0v-2.452a1.363 1.363 0 001.213-1.352c0-.75-.61-1.361-1.36-1.361zm-4.124 3.364v-.642h3.198v.642H2.836zM6.96 18.87H2.836v-.575H6.96a.288.288 0 010 .575z" />
                </g>
            </g>
        </svg>
    )
}

export { TerraceTable }
